module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iOoFu"))).then(() => parcelRequire('2KbAe'));